export default "__VITE_ASSET__Dn6X$VeX__"